'use client';

import { Cart } from 'lib/bigcommerce/types';
import { ResultJSON } from 'lib/result';
import { useEffect, useRef, useState } from 'react';
import useSWR, { Fetcher } from 'swr';
import * as MulberryService from '../product/mulberry-actions';


const fetcher: Fetcher<ResultJSON<Cart>, string> = (path) => fetch(path).then((res) => res.json());
export default function useCart() {
  const { data, mutate, error, isLoading } = useSWR("/api/cart", fetcher);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
    }
  }, [initialized]);

  const loading = initialized ? isLoading : true;

  const isMulberryInitializedRef = useRef(false);

  useEffect(() => {
    const initializeMulberry = async () => {
      if (!isMulberryInitializedRef.current) {
        try {
          MulberryService.Init();
          isMulberryInitializedRef.current = true;
        } catch (error) {
          console.error('Error initializing Mulberry services:', error);
        }
      }
    };
    initializeMulberry();
  }, []);

  if (data?.isFailure) {
    console.log(data);
  }
  if (error) {
    console.log(error);
  }

  let cart;
  if (!loading) {
    cart = data?.value;
  }

  return {
    loading,
    cartQuantity: cart?.totalQuantity ?? 0,
    cart,
    mutate
  };
}
